import { call, put } from "redux-saga/effects";
import { TOAST_SHOW } from "../Actions/ToastAction";
import { GET_LINE_INFO_DEMO_FAILED, GET_LINE_INFO_DEMO_SUCCESS, RESET_LINE_ITEM_DEMO_DATA, RESTART_LINE_ITEM_IPS_DEMO_FAILED, RESTART_LINE_ITEM_IPS_DEMO_SUCCESS, SET_LINE_ITEM_IPS_DEMO_FAILED, SET_LINE_ITEM_IPS_DEMO_SUCCESS } from "../Actions/CLineItemDemoActions";
import axios from "../../axiosConfig";


export function* GetLineInfoDemoSaga(action:any):unknown{
    try {
        const response = yield call(axios.get,`getlineinfoDemo?type=${action.payload?.type}`);
        const {data,status} = response
        if (status ===200) {
            yield put({type:GET_LINE_INFO_DEMO_SUCCESS,payload:data})
        }
    } catch (error:any) {      
        if (error.response.status === 500) {
            if (error.response.data.message) {
              yield put({
                type: TOAST_SHOW,
                payload: { message: error.response.data.message, severity: 'Danger', show: true },
              });
            }
          }else{
              yield put({
                  type: TOAST_SHOW,
                  payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
              });
          }
        yield put({type:GET_LINE_INFO_DEMO_FAILED})
        yield put({type:RESET_LINE_ITEM_DEMO_DATA})
    }
}
export function* SetLineItemIPsDemoSaga(action:any):unknown{
    try {
        const response = yield call(axios.post,'setLineItemDataDemo',action.payload)
        const {data,status} = response
        
        if (status===200||status===204) {
            yield put({type:SET_LINE_ITEM_IPS_DEMO_SUCCESS,payload:data})
            yield put({
                type: TOAST_SHOW,
                payload: { message: 'New IPS added successfully', severity: 'Success', show: true },
            });

            let {handleSuccess} = action.payload;
            if(handleSuccess){  
              handleSuccess(data) 
            }
        }
    } catch (error:any) {
        
        if (error.response.status === 500) {
            if (error.response.data.message) {
              yield put({
                type: TOAST_SHOW,
                payload: { message: error.response.data.message, severity: 'Danger', show: true },
              });
            }
          } else {
            yield put({
              type: TOAST_SHOW,
              payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
            });
          }

        yield put({type:SET_LINE_ITEM_IPS_DEMO_FAILED})
        
    }
}


export function* restartLineIPsDemoSaga(action:any):unknown{
  try {
      const response = yield call(axios.get,`restartLineItemDataDemo?type=${action?.adsType}`);
      const {data,status} = response
      
      if (status===200||status===204) {
          yield put({type:RESTART_LINE_ITEM_IPS_DEMO_SUCCESS,payload:data})
          yield put({
              type: TOAST_SHOW,
              payload: { message: 'New IPS restarted successfully', severity: 'Success', show: true },
          });

          let {handleSuccess} = action.payload;
          if(data?.startTime && handleSuccess){  
            handleSuccess(data) 
          }
      }
  } catch (error:any) {  
      if (error.response.status === 500) {
          if (error.response.data.message) {
            yield put({
              type: TOAST_SHOW,
              payload: { message: error.response.data.message, severity: 'Danger', show: true },
            });
          }
        } else {
          yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something Went wrong please try again', severity: 'Danger', show: true },
          });
        }

      yield put({type:RESTART_LINE_ITEM_IPS_DEMO_FAILED})
      
  }
}